import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import {
  captureInviteTokenFromUrl,
  isInviteLinkPath,
  scrubInviteTokenFromBreadcrumb,
  scrubInviteTokenFromEvent,
  sentryEnabledFor,
} from "./auth/inviteLink";

// MUST stay above Sentry.init. An invite link's token rides in the URL
// fragment: take it off the address bar before anything reads `location`.
captureInviteTokenFromUrl();

const dsn = import.meta.env.VITE_SENTRY_DSN ?? "";
// A document loaded from an invite link never runs Sentry. The browser's
// navigation-timing entry keeps the original URL, token included, and Replay
// and tracing both upload it — stripping the address bar cannot clear it.
const onInviteLink = isInviteLinkPath(window.location.pathname);

Sentry.init({
  dsn: dsn || undefined,
  enabled: sentryEnabledFor(window.location.pathname, dsn),
  environment: import.meta.env.MODE ?? "development",
  sendDefaultPii: false,
  tracesSampleRate: import.meta.env.DEV ? 1.0 : 0.15,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: onInviteLink
    ? []
    : [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Belt and braces behind captureInviteTokenFromUrl: redact an invite token
  // from anything that still carries one.
  beforeSend: (event) => scrubInviteTokenFromEvent(event),
  beforeSendTransaction: (event) => scrubInviteTokenFromEvent(event),
  beforeBreadcrumb: (crumb) => scrubInviteTokenFromBreadcrumb(crumb),
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
